module.exports = __webpack_public_path__ + "static/media/karsten.40daf635.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/karsten.jpg
// module id = 96
// module chunks = 0